<div class="row" *ngIf="isFreemium || data?.ivtDistribution?.byMonth?.length > 0">
    <div class="col-lg-4 col-md-4 leftOverview">
        <ul class="list-group mx-auto">
            <li class="list-group-item">
                <h5>CTR with IVT
                </h5>
                <h5 class="value">
                  <ng-container *ngIf="isFreemium && !isFollowing">
                    <div class="freemium-lock">
                      <i class="fa fa-lock"></i>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
                    {{data?.ctrDistribution?.ctr | perc:'1.2-2'}}
                  </ng-container>
                </h5>
            </li>
            <li class="list-group-item">
                <h5>
                    CTR without IVT
                </h5>
                <h5 class="value">
                  <ng-container *ngIf="isFreemium && !isFollowing">
                    <div class="freemium-lock">
                      <i class="fa fa-lock"></i>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
                    {{data?.ctrDistribution?.nonGivtSivtCtr | perc:'1.2-2'}}
                  </ng-container>
                </h5>
            </li>
        </ul>
    </div>
    <div class="col-lg-8 col-md-8 chartContainer">
      <app-line-chart [data]="lineChartData"
                      [categoryField]="'month'"
                      [valueFields]="['ctr', 'nonGivtSivtCtr']"
                      [titleArray]="['CTR with IVT', 'CTR without IVT']"
                      [height]="'500px'" [type]="'double'" [valueAxisUnit]="'%'"></app-line-chart>
      <ng-container *ngIf="data?.ctrDistribution?.adSizes?.length > 0">
        <app-data-table-component [headers]="headers" [currentSort]="'ctr'" [data]="adSizes" [asc]="true"></app-data-table-component>
      </ng-container>

    </div>
</div>
